var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 263.6 200",
    style: {
      enableBackground: "new 0 0 263.6 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.5,163.6c0,20-16.3,36.4-36.4,36.4H36.4C16.3,200,0,183.7,0,163.6H254.5z M209.1,109.1H200v4.5 c0,17.5-14.3,31.8-31.8,31.8h-100c-17.5,0-31.8-14.3-31.8-31.8V9.1c0-5,4.1-9.1,9.1-9.1h163.6c30.1,0,54.5,24.4,54.5,54.5 S239.2,109.1,209.1,109.1z M209.1,27.3H200v54.5h9.1c15.1,0,27.3-12.2,27.3-27.3S224.1,27.3,209.1,27.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeCoffee);
export default __webpack_public_path__ + "static/media/Free_Coffee.f3302dbce48fdfeadec5a851889dbf2d.svg";
export { ForwardRef as ReactComponent };